var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value === true)?_c('v-icon',{attrs:{"color":"d-green"}},[_vm._v(" mdi-bookmark-check ")]):(_vm.value === false)?_c('v-icon',{attrs:{"color":"d-red"}},[_vm._v(" mdi-bookmark-minus ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }